import * as React from 'react';
import { observer } from 'mobx-react';
import HideModal, { Props } from './HideModal';
import ModalReactions from '../../../../Modal/ModalReactions';

const Hide: React.FC<Props> = (props) => (
  <>
    <HideModal {...props} />
    <ModalReactions store={props.hideModalStore} />
  </>
);

export default observer(Hide);
